import { ComponentType, Key } from 'react';

import { DataTableClassNames } from '../../constants';
import {
  ColumnDef,
  DataTableBlurHandler,
  DataTableRowActionProps,
  DataTableRowStripColorSelector,
} from '../../types';
import BodyCell from '../BodyCell';
import { RowActionCell } from '../RowActionCell';

import { BodyRowRoot } from './styled';

type Props<TData> = {
  columns: ColumnDef<TData>[];
  item: TData;
  rowKey: Key;
  rowAction: ComponentType<DataTableRowActionProps<TData>> | undefined;
  onCellBlur: DataTableBlurHandler<TData> | undefined;
  rowStripColorSelector: DataTableRowStripColorSelector<TData> | undefined;
};

const BodyRow = <TData extends Record<string, unknown>>({
  columns,
  item,
  rowKey,
  rowAction: RowAction,
  onCellBlur,
  rowStripColorSelector,
}: Props<TData>) => (
  <BodyRowRoot $stripColor={rowStripColorSelector?.(item)} data-row={rowKey}>
    {columns.map(column => (
      <BodyCell
        column={column}
        item={item}
        key={column.key?.toString()}
        rowKey={rowKey.toString()}
        onBlur={newValue => onCellBlur?.(newValue)}
      />
    ))}
    {RowAction ? (
      <RowActionCell key={DataTableClassNames.Action}>
        <RowAction data={item} rowKey={rowKey} />
      </RowActionCell>
    ) : undefined}
  </BodyRowRoot>
);

export default BodyRow;
